<template>
  <router-view/>
</template>
<script setup>
import { onMounted } from "vue";
import DevicePixelRatio from "./utils/evicePixelRatio";
import {useTgaStore} from "@/store/tga.js";
import {useRoute} from "vue-router";
const route = useRoute();
useTgaStore().tgaInit()
onMounted(() => {
  if (route.meta.zoom) {
    new DevicePixelRatio().init();
  }

})
</script>
<style lang="scss">
</style>
